/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Embedding} from '../../core/_models'
import moment from 'moment'

type Props = {
  embeddings: Embedding
}

const UserJoinedDate: FC<Props> = ({embeddings}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}

    <div className='d-flex flex-column'>{moment(embeddings.createdAt).format('MM-DD-YYYY')}</div>
  </div>
)

export {UserJoinedDate}
